module.exports = __webpack_public_path__ + "453732f11cad9bfcf5e1d5e96ea60be4.jpg";